import React, { Component } from 'react';
import { Translation } from 'giro-react-toolkit/source/Translation';

import "./ErrorBanner.scss";

const ErrorBannerContext = React.createContext();
const Consumer = ErrorBannerContext.Consumer;

/**
 * Error banner provider
 */
class ErrorBannerProvider extends Component {
   constructor(props) {
      super(props);
      this.state = {
         message: undefined,
         param:  undefined,
         retry: undefined
      }
   }

   /**
    * display error message in banner
    * @param message message resource key
    * @param param parameters for the resource
    * @param retry lambda to be executed on retry click
    */
   displayErrorMessage(message, param, retry) {
      this.setState({message: message, param: param, retry: retry});
   }

   render() {
      return (
         <ErrorBannerContext.Provider
            value={{
               displayErrorMessage: (msg, param, retry) => this.displayErrorMessage(msg, param, retry),
               closeErrorBanner: () => this.displayErrorMessage(undefined, {}, undefined),
               message: this.state.message,
               msgParams: this.state.param,
               retryFct: this.state.retry
            }}>
            {this.props.children}
         </ErrorBannerContext.Provider>);
   }
}

/**
 * Error banner, shows error in provider in a banner
 */
function ErrorBanner() {
   return (
      <Consumer>
         {({ message, msgParams, retryFct, closeErrorBanner }) => (
            message ?
               (<div className="error-banner">
                  <div className="error-banner__icon"></div>
                  <div className="error-banner__message">
                     <Translation resourceKey={message} params={msgParams} />
                  </div>
                  <div className="error-banner__buttons">
                     {retryFct ?
                        <button type="button" onClick={() => {
                           closeErrorBanner();
                           retryFct();
                        }}>
                           <Translation resourceKey="ReachMapRes.RetryText" />
                        </button>
                        : null }
                     <button type="button" onClick={closeErrorBanner}>
                        <Translation resourceKey="ReachMapRes.CloseText" />
                     </button>
                  </div>
               </div>)
               : null
         )}
      </Consumer>);
}

export { ErrorBannerProvider, Consumer as ErrorBannerConsumer, ErrorBannerContext, ErrorBanner };
